import React from 'react';
import moment from 'moment';

// Styled
import { HoverCopy } from 'styled/common';

// Components
import Copy from 'components/Copy';
import StatusLabel from 'components/StatusLabel';

// Constants
import { FORMATS } from 'constants/date';

export const options = [
  {
    text: 'IP Whitelist',
    value: 'IP Whitelist',
  },
  {
    text: 'Public Key',
    value: 'Public Key',
  },
];

export const API_KEYS_COLUMN_ID = [
  {
    accessorKey: 'addedOn',
    header: 'Date & Time',
    ellipsis: true,
    width: 80,
    cell: ({ addedOn }) => moment(addedOn).format(FORMATS.TIMESTAMP),
  },
  {
    accessorKey: 'generatedBy',
    header: 'Generated By',
    ellipsis: true,
    width: 80,
    cell: ({ generatedBy }) => generatedBy || '-',
  },
  {
    accessorKey: 'merchantIP',
    header: 'IP Address',
    ellipsis: true,
    width: 140,
    cell: ({ merchantIP }) => (
      <HoverCopy>
        <span>{merchantIP}</span>
        <Copy value={merchantIP} />
      </HoverCopy>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    width: 180,
    ellipsis: true,
    cell: status => (
      <StatusLabel>
        {status.isApproved ? 'ACTIVE' : 'PENDING_APPROVAL'}
      </StatusLabel>
    ),
  },
];

export const API_KEYS_COLUMN_ID_PUBLIC_KEY = [
  {
    accessorKey: 'addedOn',
    header: 'Generated At',
    ellipsis: true,
    width: 80,
    cell: ({ addedOn }) => moment(addedOn).format(FORMATS.TIMESTAMP),
  },
  {
    accessorKey: 'generatedBy',
    header: 'Generated By',
    ellipsis: true,
    width: 80,
    cell: ({ generatedBy }) => generatedBy || '-',
  },
  {
    accessorKey: ' ',
    header: 'Public Key',
    ellipsis: true,
    width: 80,
    cell: () => <>xxxxxxxxxxxxxxxx</>,
  },
];

export const MODAL_TYPES = {
  ADD: 'ADD',
  SWITCH: 'SWITCH',
  GENERATE: 'GENERATE',
  DELETE_IP: 'DELETE_IP',
  DELETE_PUBLIC_KEY: 'DELETE_PUBLIC_KEY',
};
